module.exports = __webpack_public_path__ + "static/media/marker-icon-2x-9d5c10.ace08ba6.png";